/** Имя таблицы списка диалогов — ключ её настроек и пресетов в настройках пользователя */
export const DIALOGS_TABLE_NAME = 'dialogsListV2';

export const MAIN_COLUMNS = {
  id: 'id',
  externalId: 'externalId',
  createdAt: 'createdAt',
  processedAt: 'processedAt',
  duration: 'duration',
  client: 'client',
  employeeId: 'employeeId',
  hasTranscription: 'hasTranscription',
} as const;

export type MainColumnKey = keyof typeof MAIN_COLUMNS;

export const MAIN_COLUMN_KEYS = Object.keys(MAIN_COLUMNS) as MainColumnKey[];

// Видимы только перечисленные колонки, остальные основные скрыты по умолчанию
export const DEFAULT_MAIN_COLUMNS = ['createdAt', 'client', 'employeeId'];

/**
 * События диалога, отбираемые к показу в транскрипте и на шкале записи:
 * - `pause` — паузы;
 * - `interruption` — перебивания любой стороной;
 * - `interruption_client` — перебивания клиентом;
 * - `interruption_employee` — перебивания консультантом.
 *
 * Три варианта перебивания взаимоисключающие.
 */
export const DIALOG_EVENT_FILTERS = ['pause', 'interruption', 'interruption_client', 'interruption_employee'] as const;

/** Событие диалога, отбираемое к показу */
export type DialogEventFilter = (typeof DIALOG_EVENT_FILTERS)[number];

/** Отбор событий, пока пользователь свой не выставил */
export const DEFAULT_DIALOG_EVENT_FILTERS: DialogEventFilter[] = ['pause', 'interruption'];
